module.exports = __webpack_public_path__ + "static/bengo4-e6ec5b1465413d9c57489be93637e787.svg";